import "./App.css";

function App() {
  return (
    <div className="App">
      <p>Welcome to the Siren Systems API</p>
    </div>
  );
}

export default App;
